import React, { Component } from "react";
import PropTypes from "prop-types";
import Downshift from "downshift";
import CompanyDetailForm from "./company_detail_form";
import CareerForm from "./career_form";
import LogoImage from "./logo_image";
import InvalidFeedback from "../common/invalid_feedback";
import Api from "./api";

const api = new Api;

class StartupForm extends Component {
  fetchRepository = this.debounce(value => {
    api.showCompanies(value).then(result => {
      result.push({id: null, name: value});
      this.setState({autocompleteItems: result});
    });
  }, 300);

  constructor(props) {
    super(props);

    this.emptyExperience = {
      title: "",
      start_date: "",
      end_date: "",
      current: false,
      description: "",
      errors: {},
    };

    this.state = {
      user: {
        belonged_organization: true,
      },
      company: {
        id: "",
        name: "",
        concept_pitch: "",
        website_url: "",
        logo_image: "",
        errors: {},
      },
      career: {
        experiences_attributes: [ Object.assign({}, this.emptyExperience) ],
        errors: {},
      },
      companyPreviewLogoImage: {
        file_name: "画像ファイルの選択",
        url: "",
      },
      isShowCompanyDetail: false,
      autocompleteItems: [],
    };

    this.onCompanyInputChange = this.onCompanyInputChange.bind(this);
    this.onCompanyLogoImageChange = this.onCompanyLogoImageChange.bind(this);
    this.onExperieceInputChange = this.onExperieceInputChange.bind(this);
  }

  onCompanyInputChange(event, company, value) {
    company[event.target.name] = value;
    this.setState(prevState => ({company: prevState.company}));
  }

  onCompanyLogoImageChange(event, company) {
    const file = event.target.files[0];
    const file_name = event.target.value.replace(/\\/g, "/").replace(/.*\//, "");

    this.onCompanyInputChange(event, company, file);

    if (!file) return;
    if (/^image/.test(file.type)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({companyPreviewLogoImage: {file_name: file_name, url: reader.result}});
      };
      reader.readAsDataURL(file);
    }
  }

  onExperieceInputChange(event, experience, value) {
    experience[event.target.name] = value == null ? event.target.value : value;
    this.setState(prevState => ({career: prevState.career}));
  }

  handleCompanyCheckChange(event, company, career) {
    const isBelonged = !event.target.checked;

    if (!isBelonged) {
      this.initErrors(company, career);
    }

    this.setState({user: {belonged_organization: isBelonged}});
  }

  initErrors(company, career) {
    company.errors = {};
    career.errors = {};
    career.experiences_attributes.forEach(experience => { experience.errors = {}; });

    this.setState(prevState => ({
      company: prevState.company,
      career: prevState.career
    }));
  }

  handleAutoComplete(event) {
    const value = event.target.value;
    if (!value) {
      return;
    }
    this.fetchRepository(value);
  }

  handleFormSubmit(user, company, career) {
    api.postStartup(JSON.stringify({
      user: user,
      company: company,
      career: career
    })).then(result => {
      window.location = result.location;
    }).catch(error => {
      this.setState({
        company: error.response.data.company,
        career: error.response.data.career
      });
    });
  }

  debounce(fn, time) {
    let timeoutId;
    return wrapper;

    function wrapper(...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        timeoutId = null;
        fn(...args);
      }, time);
    }
  }

  renderAutoCompleteInput(user, company, autocompleteItems, defaultCompanyLogoImageUrl) {
    return (
      <Downshift
        onChange={selection => {
          company.id = selection === null ? "" : selection.id;
          company.name = selection === null ? "" : selection.name;
          this.setState({company: company});
        }}
        itemToString={item => (item ? item.name : "")}
      >
        {({
          selectedItem,
          getInputProps,
          getItemProps,
          highlightedIndex,
          clearSelection,
          isOpen,
        }) => {
          return (
            <div>
              <div className='input-group mb-1'>
                <input
                  {...getInputProps({
                    onChange: event => {
                      this.handleAutoComplete(event);
                    },
                    placeholder: "サイバーエージェント ※「株式会社」などは省略",
                  })}
                  id='company-name-input'
                  className={`form-control ${company.errors.name ? "is-invalid" : ""}`}
                  required='required'
                  type='text'
                  name='company[name]'
                  disabled={!user.belonged_organization}
                />

                {selectedItem ? (
                  <div className='input-group-append'>
                    <button
                      type='button'
                      className='input-group-text'
                      onClick={() => {
                        this.setState({isShowCompanyDetail: false});
                        clearSelection();
                      }}
                    >
                      ×
                    </button>
                  </div>
                ) : null}

                <InvalidFeedback errors={company.errors.name} label='会社名' />
              </div>

              {isOpen && (
                <ul className='company-search list-group company-list'>
                  {autocompleteItems.map((item, index) => (
                    <li
                      key={item.id}
                      {...getItemProps({
                        item,
                        style: {
                          backgroundColor:
                            highlightedIndex === index ? "#eee5fb" : "white",
                          fontWeight: selectedItem === item ? "bold" : "normal",
                        },
                        onClick: () => {
                          this.setState({isShowCompanyDetail: item.id ===  null ? true : false});
                        }
                      })}
                      className='list-group-item'
                    >
                      <LogoImage item={item} defaultCompanyLogoImageUrl={defaultCompanyLogoImageUrl} />
                      {item.id == null ? item.name + "を追加" : item.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        }}
      </Downshift>
    );
  }

  render() {
    const { user, company, career, companyPreviewLogoImage, isShowCompanyDetail, autocompleteItems } = this.state;
    const { defaultCompanyLogoImageUrl } = this.props;

    return (
      <React.Fragment>
        <div className='row d-flex justify-content-center'>
          <form data-remote='true' className='col-12 col-lg-10'>
            <div className='form-group row'>
              <label className='col-12 col-md-6 col-form-label required' htmlFor='company-name-input'>
                会社名
              </label>
              <div className='col-12 col-md-6'>
                {this.renderAutoCompleteInput(user, company, autocompleteItems, defaultCompanyLogoImageUrl)}
                <div className='form-check'>
                  <label className='form-check-label' htmlFor='company-name-check'>
                    <input
                      onChange={event => this.handleCompanyCheckChange(event, company, career)}
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      id='company-name-check'
                    />
                  会社に所属していない
                  </label>
                </div>
              </div>
            </div>

            <CompanyDetailForm
              show={isShowCompanyDetail}
              company={company}
              companyPreviewLogoImage={companyPreviewLogoImage}
              defaultCompanyLogoImageUrl={defaultCompanyLogoImageUrl}
              onCompanyInputChange={this.onCompanyInputChange}
              onCompanyLogoImageChange={this.onCompanyLogoImageChange}
            />

            <CareerForm
              user={user}
              career={career}
              onExperieceInputChange={this.onExperieceInputChange}
            />

            <div className='row d-flex justify-content-center'>
              <div className='col-12 m-5 col-md-6 offset-md-3'>
                <button
                  type='button'
                  onClick={() => this.handleFormSubmit(user, company, career)}
                  className='btn btn-primary btn-lg btn-block m-auto'
                >
                次へ進む
                </button>
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }
}

StartupForm.propTypes = {
  defaultCompanyLogoImageUrl: PropTypes.string.isRequired
};

export default StartupForm;
